import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService, UserService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { PersonAddressService } from '../person-address.service';
import { PersonAddress } from '../person-address';
import { PersonService } from '@app/_components/person/person.service';
import { ConstantService } from '@app/_services/constant.service';

@Component({
    selector: 'app-person-address',
    templateUrl: './person-address.component.html',
    styleUrls: ['./person-address.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class PersonAddressComponent implements OnInit {
    personId: any;
    persons: any;
    countries: any[];
    addressTypes: any;

	constructor(
		private constantService: ConstantService,
		private personService: PersonService,
		private primengConfig: PrimeNGConfig,
		private personAddressService: PersonAddressService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.personAddress = data.personAddress,
			this.personId = data.personId,
			this.addressTypes =  this.personService.addressTypes;
			this.countries =  this.constantService.countries;
			this.states =  this.constantService.states;
	}

	@Input() personAddress: PersonAddress;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	personAddressId: number;
	states: any;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'personAddressId': [],
		'type': [
			{ type: 'required', message: 'Required' },],
		'adrStreet': [],
		'adrStreet2': [],
		'adrCity': [],
		'adrState': [],
		'adrPostalCode': [],
		'adrCountry': [],
		'personId': [],
	};

	ngOnInit() {
		this.fetchPersons();
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole personAddress object
		if (this.personAddress) {
			this.personAddressId = this.personAddress.personAddressId;
			this.fixDates();
			this.form1.patchValue(this.personAddress);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.personAddressId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.form1.value.personId = this.personId;
			this.personAddressService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.personAddress = res.data.address;
						this.doAdd.emit(this.personAddress);
					},
					(err: any) => {
						console.log('personAddress-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('personAddress: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.personAddressService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.personAddress = res.data.address;
						this.doUpdate.emit(this.personAddress);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.personAddressService.delete(this.personAddress.personAddressId)
				.subscribe(
					(res: any) => {
						console.log('personAddress-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.personAddress);
					},
					(err: any) => {
						console.log('personAddress-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			personAddressId: [this.personAddressId],
			type: ['', Validators.required],
			adrStreet: [],
			adrStreet2: [],
			adrCity: [],
			adrState: [],
			adrPostalCode: [],
			adrCountry: [],
			personId: [],
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.personAddress.personAddressDate = moment(this.personAddress.personAddressDate).toDate();
	}
	
	fetchPersons() {
		if (!this.persons || this.persons === undefined || this.persons.length < 1) {
			try {
				this.personService.findAll()
					.subscribe(
						res => {
							console.log('findAllPersons: ' + JSON.stringify(res));
							this.persons = res.data.persons;
							return this.persons;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
		else {
			// console.log('properties are ' + this.properties);
			return (this.persons);
		}
	}
}
